/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Education } from '../../models/education';

export interface UpdateEducation$Params {
  profileId: string;
  id: string;
      body?: Education
}

export function updateEducation(http: HttpClient, rootUrl: string, params: UpdateEducation$Params, context?: HttpContext): Observable<StrictHttpResponse<Education>> {
  const rb = new RequestBuilder(rootUrl, updateEducation.PATH, 'put');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Education>;
    })
  );
}

updateEducation.PATH = '/studentprofile/{profileId}/education/{id}';
